if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super()
        this.init()
      }

      init() {
        this.elements = this.getElements()
        this.mql = window.matchMedia('(min-width: 750px)')
        this.currentIndex = 0
        this.thumbnailsCount = this.elements.thumbnails
          ? this.elements.thumbnails.querySelectorAll('[data-target]').length
          : 0

        if (!this.elements.thumbnails) return

        this.setupEventListeners()
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
          this.removeListSemantic()
        }
        // this.updateNavigationButtonsVisibility()
        this.updatePrevWrapperClass()
      }

      getElements() {
        return {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
          dots: Array.from(this.querySelectorAll('.custom-slider-dot')),
          prevButton: this.querySelector('.custom-prev-slide'),
          nextButton: this.querySelector('.custom-next-slide'),
          prevWrapper: this.querySelector('.custom-prev-wrapper'),
        }
      }

      setupEventListeners() {
        this.elements.viewer.addEventListener('slideChanged', this.onSlideChanged.bind(this))
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', () => this.setActiveMedia(mediaToSwitch.dataset.target, false))
        })
        this.elements.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.onDotClick(index))
        })
        if (this.elements.prevButton) {
          this.elements.prevButton.addEventListener('click', this.onPrevClick.bind(this))
        }
        if (this.elements.nextButton) {
          this.elements.nextButton.addEventListener('click', this.onNextClick.bind(this))
        }
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`,
        )
        this.setActiveThumbnail(thumbnail)
        this.currentIndex = this.getMediaIndex(thumbnail)
        this.setActiveDot(this.currentIndex)
        // this.updateNavigationButtonsVisibility()
        this.updatePrevWrapperClass()
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]')
        if (!activeMedia) return

        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active')
        })
        activeMedia.classList.add('is-active')

        if (prepend) {
          this.prependActiveMedia(activeMedia, mediaId)
        }

        this.preventStickyHeader()
        this.scrollToActiveMedia(activeMedia)
        this.playActiveMedia(activeMedia)

        if (!this.elements.thumbnails) return
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`)
        this.setActiveThumbnail(activeThumbnail)
        this.currentIndex = this.getMediaIndex(activeThumbnail)
        this.setActiveDot(this.currentIndex)
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition)
        // this.updateNavigationButtonsVisibility()
        this.updatePrevWrapperClass()
      }

      prependActiveMedia(activeMedia, mediaId) {
        if (activeMedia.parentElement.firstChild !== activeMedia) {
          activeMedia.parentElement.prepend(activeMedia)
        }

        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`)
          if (activeThumbnail.parentElement.firstChild !== activeThumbnail) {
            activeThumbnail.parentElement.prepend(activeThumbnail)
          }
        }

        if (this.elements.viewer.slider) {
          this.elements.viewer.resetPages()
        }
      }

      scrollToActiveMedia(activeMedia) {
        requestAnimationFrame(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft })
          }
          const activeMediaRect = activeMedia.getBoundingClientRect()
          if (activeMediaRect.top > -0.5) return
          const top = activeMediaRect.top + window.scrollY
          window.scrollTo({ top, behavior: 'smooth' })
        })
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'))
        thumbnail.querySelector('button').setAttribute('aria-current', true)

        if (!this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft })
        }
      }

      setActiveDot(index) {
        this.elements.dots.forEach((dot, i) => {
          dot.classList.toggle('active', i === index)
        })
      }

      onDotClick(index) {
        const thumbnails = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'))
        if (thumbnails[index]) {
          const mediaId = thumbnails[index].dataset.target
          this.setActiveMedia(mediaId, false)
        }
      }

      onPrevClick() {
        this.currentIndex = (this.currentIndex - 1 + this.thumbnailsCount) % this.thumbnailsCount
        console.log(this)
        this.setActiveMediaByIndex(this.currentIndex)
        this.updatePrevWrapperClass()
      }

      onNextClick() {
        this.currentIndex = (this.currentIndex + 1) % this.thumbnailsCount
        console.log(this)
        this.setActiveMediaByIndex(this.currentIndex)
        this.updatePrevWrapperClass()
      }

      setActiveMediaByIndex(index) {
        const thumbnails = Array.from(this.elements.thumbnails.querySelectorAll('[data-target]'))
        const mediaId = thumbnails[index].dataset.target
        this.setActiveMedia(mediaId, false)
      }

      getMediaIndex(thumbnail) {
        return Array.from(this.elements.thumbnails.querySelectorAll('[data-target]')).indexOf(thumbnail)
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img')
        if (!image) return

        if (image.complete) {
          this.updateLiveRegion(position)
        } else {
          image.onload = () => this.updateLiveRegion(position)
        }
      }

      updateLiveRegion(position) {
        this.elements.liveRegion.setAttribute('aria-hidden', false)
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position)
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true)
        }, 2000)
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia()
        const deferredMedia = activeItem.querySelector('.deferred-media')
        if (deferredMedia) deferredMedia.loadContent(false)
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header')
        if (!this.stickyHeader) return
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'))
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return
        this.elements.viewer.slider.setAttribute('role', 'presentation')
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'))
      }

      updateNavigationButtonsVisibility() {
        if (this.elements.prevButton) {
          this.elements.prevButton.style.opacity = this.currentIndex === 0 ? '0' : '1'
        }
        if (this.elements.nextButton) {
          this.elements.nextButton.style.opacity = this.currentIndex === this.thumbnailsCount - 1 ? '0' : '1'
        }
      }

      updatePrevWrapperClass() {
        if (this.elements.prevWrapper) {
          if (this.currentIndex === 0) {
            this.elements.prevWrapper.classList.add('mobile-width')
          } else {
            this.elements.prevWrapper.classList.remove('mobile-width')
          }
        }
      }
    },
  )
}
